import type { ReactNode } from 'react';

import { useAuth } from '@/auth/AuthContext';

export function AdminShell({ children }: { children: ReactNode }) {
  const auth = useAuth();
  if (auth.status.state === 'loading') return <StatePage title="Loading" detail="Checking the admin session…" status="Loading" />;
  if (auth.status.state === 'signed_out') return <StatePage title="Chess Playbook Admin" detail="Sign in with the founder account to continue." status="Signed out"><button onClick={() => void auth.signIn()}>Sign in</button></StatePage>;
  if (auth.status.state === 'not_authorized') return <StatePage title="Not authorized" detail="This account is signed in but is not on the admin allow-list." status="Access denied"><button className="secondary" onClick={auth.signOut}>Sign out</button></StatePage>;
  if (auth.status.state === 'error') return <StatePage title="Admin API unavailable" detail={auth.status.message} status="Error"><button className="secondary" onClick={auth.retry}>Retry</button></StatePage>;

  return <div className="app-shell">
    <header><div><strong>Chess Playbook</strong><span>Operations</span></div><div className="account"><span>{auth.status.me.email}</span><button className="link-button" onClick={auth.signOut}>Sign out</button></div></header>
    <main>{children}</main>
  </div>;
}

function StatePage({ title, detail, status, children }: { title: string; detail: string; status: string; children?: ReactNode }) {
  return <main className="state-page"><div className="state-card"><span className="status-label" role="status">{status}</span><h1>{title}</h1><p>{detail}</p>{children}</div></main>;
}
